import { render, staticRenderFns } from "./praticeHomeBrushQuestions.vue?vue&type=template&id=2566dfdb&scoped=true&"
import script from "./praticeHomeBrushQuestions.vue?vue&type=script&lang=js&"
export * from "./praticeHomeBrushQuestions.vue?vue&type=script&lang=js&"
import style0 from "./praticeHomeBrushQuestions.vue?vue&type=style&index=0&id=2566dfdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566dfdb",
  null
  
)

export default component.exports